/* PAMO-COD-SPLIT-3NOV · Escribe en cada línea la propiedad oculta _pamo_carrito = "variant_id:cantidad,..." de TODO el carrito,
   para que PAMO Envíos (v1.6.5+) sepa si Shopify partió el carrito por bodega. No cambia cantidades ni precios.
   Revertir: python3 /workspace/contraentrega-multibodega-3nov/revertir.py --confirmo-live */
(function () {
  if (window.__pamoMarca) return; window.__pamoMarca = 1;
  var F = window.fetch.bind(window), K = '_pamo_carrito', R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var corriendo = null, otraVez = false, t = 0, ultimo = '';
  function firma(c) { var m = {}, o = []; (c.items || []).forEach(function (i) { var v = String(i.variant_id); if (!(v in m)) { m[v] = 0; o.push(v); } m[v] += i.quantity; }); return o.map(function (v) { return v + ':' + m[v]; }).join(','); }
  function pendiente(c, s) { var it = c.items || []; for (var i = 0; i < it.length; i++) { if (!it[i].properties || it[i].properties[K] !== s) return i + 1; } return 0; }
  function json(r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }
  async function sincronizar() {
    var c = await F(R + 'cart.js', { credentials: 'same-origin' }).then(json);
    for (var n = 0; n < 60; n++) {
      var s = firma(c), l = pendiente(c, s);
      if (!l) { ultimo = s; return c; }
      var it = c.items[l - 1], p = {}; Object.keys(it.properties || {}).forEach(function (k) { p[k] = it.properties[k]; }); p[K] = s;
      c = await F(R + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: l, quantity: it.quantity, properties: p }) }).then(json);
    }
    return c;
  }
  function correr() {
    if (corriendo) { otraVez = true; return corriendo; }
    corriendo = sincronizar().catch(function (e) { console.warn('[pamo-marca]', e && e.message); }).then(function () { corriendo = null; if (otraVez) { otraVez = false; return correr(); } });
    return corriendo;
  }
  function programar() { clearTimeout(t); t = setTimeout(correr, 350); }
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (u) { var p = F.apply(window, arguments); try { var url = typeof u === 'string' ? u : (u && u.url) || ''; if (RX.test(url)) p.then(programar, programar); } catch (e) {} return p; };
  var xo = XMLHttpRequest.prototype.open; XMLHttpRequest.prototype.open = function (m, u) { try { if (RX.test(String(u))) this.addEventListener('loadend', programar); } catch (e) {} return xo.apply(this, arguments); };
  function alCheckout(ev) {
    var el = ev.target && ev.target.closest && ev.target.closest('[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"]');
    if (!el || el.__pamoOk) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var ir = function () { el.__pamoOk = 1; window.location.href = R + 'checkout'; };
    var to = setTimeout(ir, 4000);
    (corriendo || correr()).then(function () { return corriendo || correr(); }).then(function () { clearTimeout(to); ir(); }, function () { clearTimeout(to); ir(); });
  }
  document.addEventListener('click', alCheckout, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', correr); else correr();
  window.pamoMarcaCarrito = correr;
})();
